// extracted by mini-css-extract-plugin
export default {"changeInstructorButton":"UpdateInstructorButton_changeInstructorButton__qVB0J"};